import riot from 'riot';
import events from '../src/events.js';
import { openSensorSetupGuide, getSupplyDisplayName, areSensorsLoaded } from '../src/lib.js';
riot.tag2('activity-supplies', '<div class="columns is-multiline"> <div class="column is-4" each="{s in parent.parent.selectedActivity.lesson.supplies}"> <div class="card" style="display:flex; flex-direction:column; height:100%;"> <div class="card-content"> <div class="media"> <div class="media-left"> <figure class="image is-48x48" if="{s.img}"> <img riot-src="img/{s.img}" alt="{s.name}"> </figure> <figure class="image is-48x48" if="{!s.img}"> <img src="img/brand/Edjro_Logo_Mark_Emerald.png" alt="{s.name}"> </figure> </div> <div class="media-content"> <p class="title is-4">{s.type === \'sensor\' && !sensorsReady ? \'Loading…\' : getSupplyDisplayName(s)}</p> <p class="subtitle is-6" if="{s.in_kit}"> <span class="tag is-success">Included</span> </p> <p class="subtitle is-6" if="{!s.in_kit}"> <span class="tag is-light">Not Included</span> </p> </div> <div class="media-right"> <button class="button is-warning is-small" if="{s.in_kit}" onclick="{showSetupInfo}"> <span class="icon is-small"> <i class="fas fa-info"></i> </span> </button> </div> </div> <div class="content"> {s.description} </div> <div class="content has-text-centered"> <button class="button is-info {hasSupply(s.name)?\'\':\'is-light\'}" onclick="{toggleSupply}"> <span class="icon is-small" if="{hasSupply(s.name)}"> <i class="fas fa-check"></i> </span> <span>I have the {s.type === \'sensor\' && !sensorsReady ? \'Loading…\' : getSupplyDisplayName(s)} ready!</span> </button> </div> </div> </div> </div> </div>', '', '', function(opts) {
        var self = this;
        self.has_supplies = [];

        self.getSupplyDisplayName = getSupplyDisplayName;

        self.sensorsReady = areSensorsLoaded();
        events.on('sensors_ready', function() {
            self.sensorsReady = true;
            self.update();
        });

        this.toggleSupply = function(e) {
            sup_index = self.has_supplies.indexOf(e.item.s.name);
            if (sup_index === -1) {

                self.has_supplies.push(e.item.s.name);
            } else {

                self.has_supplies.splice(sup_index, 1);
            }
        }.bind(this)

        this.hasSupply = function(s_name) {
            supply_index = self.has_supplies.indexOf(s_name);
            if (supply_index === -1) {
                return false
            } else {
                return true
            }
        }.bind(this)

        this.showSetupInfo = function(e) {
            var supply = e.item.s;
            openSensorSetupGuide(supply.name);
        };
});
